export default {
    leadSourcesList: [
        {
            'id': 1,
            'name': 'Google',
            'code': 'google'
        },
        {
            'id': 2,
            'name': 'Bing',
            'code': 'bing'
        },
        {
            'id': 21,
            'name': 'Duckduckgo',
            'code': 'duckduckgo'
        },
        {
            'id': 22,
            'name': 'Yahoo',
            'code': 'yahoo'
        },
        {
            'id': 23,
            'name': 'OPSWAT Website',
            'code': 'opwast_website'
        },
        {
            'id': 24,
            'name': 'OPSWAT Academy Website',
            'code': 'opwast_academy_website'
        },
        {
            'id': 25,
            'name': 'Third-party Website',
            'code': 'third_party_website'
        },
        {
            'id': 26,
            'name': 'Email',
            'code': 'email'
        },
        {
            'id': 5,
            'name': 'YouTube',
            'code': 'youtube'
        },
        {
            'id': 27,
            'name': 'X',
            'code': 'x'
        },
        {
            'id': 28,
            'name': 'Instagram',
            'code': 'instagram'
        },
        {
            'id': 29,
            'name': 'Linkedin',
            'code': 'linkedin'
        },
        {
            'id': 4,
            'name': 'Facebook',
            'code': 'facebook'
        },
        {
            'id': 6,
            'name': 'Event',
            'code': 'event'
        },
        {
            'id': 7,
            'name': 'Referral: Channel Partner',
            'code': 'channel_partner'
        },
        {
            'id': 30,
            'name': 'Referral: OPSWAT Employee',
            'code': 'opswat_employee'
        },
        {
            'id': 31,
            'name': 'Referral: OPSWAT Academy Student',
            'code': 'opswat_academy_student'
        },
        {
            'id': 3,
            'name': 'AI-driven chatbot (e.g. ChatGPT)',
            'code': 'ai'
        },
        {
            'id': 9,
            'name': 'Other',
            'code': 'other'
        }
    ]
};

export const allowReferralSourceDetail = ['event', 'channel_partner', 'opswat_employee', 'opswat_academy_student', 'third_party_website', 'other'];
